import { render, staticRenderFns } from "./ContactusContent.vue?vue&type=template&id=0677e110"
import script from "./ContactusContent.vue?vue&type=script&lang=ts"
export * from "./ContactusContent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports